// Children of ViewAuthenticated for Amplitude and deprecated analytics redirects
export const amplitudeRoutes = [
    {
        path: 'amplitude',
        component: () => import('@/features/amplitude/views/AmplitudeRouterView.vue'),
        meta: { title: 'Amplitude' },
        children: [
            {
                path: '',
                components: {
                    default: () => import('@/features/amplitude/views/AmplitudeIndexView.vue'),
                    heading: () => import('@/features/amplitude/components/AmplitudeIndexHeading.vue'),
                },
                name: 'amplitude-index',
                meta: { title: 'Amplitude' },
            },
        ],
    },

    // Deprecated Ananlytics route -> price-intelligence
    {
        path: 'analytics',
        meta: { title: 'Analytics' },
        children: [
            {
                path: '',
                name: 'analytics',
                redirect: { name: 'pi-index' },
            },
            {
                path: 'payer',
                meta: { title: 'Payer Reimbursements' },
                redirect: { name: 'pi-index' },
            },
        ],
    },
    {
        path: 'price-intelligence',
        children: [
            {
                path: '',
                name: 'pi-index',
                redirect: { name: 'amplitude-index' },
            },
            {
                path: 'payer-contracts',
                name: 'pi-payer-contracts',
                redirect: { name: 'amplitude-index' },
            },
        ],
    },
]
